import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
    // configs
    sectionId='tax-documents-intro'
    moduleName='intro-module'
    moduleVariation='A'
    // content
    headingText={<>All your account and contract tax details in <WidowBlock>one place</WidowBlock></>}
    introContent={(
      <Typography
        align='left'
        disableBottomPadding>
        Let&#39;s make tax time a little less taxing on you. Whether you own a Northwestern Mutual insurance policy or annuity, or you invest with us, our Tax Resource Center has what you need. Find the answers to your questions. Get tips to help you prepare for tax season. See when your tax forms will be mailed to you or available to download. And more.
      </Typography>
    )}
  />
);
